// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1-lOO","container":"styles_container__7t9dk","title":"styles_title__3KEh6","wrapper":"styles_wrapper__qWVrC","answer":"styles_answer__57AW5"};